import get from 'lodash/get';

/**
 * Returns an array of readable answers which have been submitted so far (up to page $maxPage)
 * The array contains an object with the structure {questionId(int), question(string), answer(string)}
 */
export default class ReadableAnswersFormatter {
    constructor(questionsPerPage, submittedAnswers, maxPage)
    {
        this.questionsPerPage = questionsPerPage;
        this.submittedAnswers = submittedAnswers;
        this.maxPage  = maxPage;
    }

    getAnswers()
    {
        let answerCollection = [];

        for (const [pageNumber, questions] of Object.entries(this.questionsPerPage)) {
            // Stop if we've passed the max page
            if (pageNumber >= this.maxPage) {
                return answerCollection;
            }

            this.getAnswersForPage(answerCollection, questions);
        }

        return answerCollection;
    }

    getAnswersForPage(answerCollection, questions)
    {
        // Get answers for questions for this page
        questions.forEach((question) => {
            let answer = get(this.submittedAnswers, question.id);

            if (typeof answer !== 'undefined' && answer !== null && answer !== '') {
                answerCollection.push({
                    questionId: question.id,
                    question: question.question,
                    answer: this.getReadableAnswer(question, answer)
                });
            }
        });
    }

    getReadableAnswer(question, questionAnswer)
    {
        switch (question.question_type) {
            case 'open':
                return questionAnswer;
            case 'email':
                return questionAnswer;
            case 'radio':
                return this.getReadableRadioAnswer(question, questionAnswer);
            case 'checkboxes':
                return this.getReadableCheckboxesAnswer(question, questionAnswer);
        }
        return null;
    }

    getReadableRadioAnswer(question, questionAnswer)
    {
        for (const [key] in question.options) {
            let option = question.options[key];
            if (option.id === questionAnswer) {
                return option.title;
            }
        }
        return null;
    }

    getReadableCheckboxesAnswer(question, questionAnswers)
    {
        if(!Array.isArray(questionAnswers)){
            return '';
        }

        if(questionAnswers.length === 0){
            return '';
        }

        let results = [];

        questionAnswers.forEach((optionId) => {
            const readableResult = this.getReadableRadioAnswer(question, optionId);
            if(readableResult !== null){
                results.push(readableResult);
            }
        });

        return results.join(', ');
    }



    getQuestion(questionId)
    {
        return get(this.questionsPerPage, questionId);
    }

}
